if (!customElements.get('bb-product-form')) {
  customElements.define(
    'bb-product-form',
    class BbProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.setSubmitLoadingState(true);

        const complementaryItems = this.getSelectedComplementaryProducts();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;

        let sections;
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map(section => section.id);
          this.cart.setActiveElement(document.activeElement);
        }

        // ✅ MULTI-ITEM → JSON (REQUIRED)
        if (complementaryItems.length > 0) {
          const items = [
            { id: mainVariantId, quantity }
          ];

          complementaryItems.forEach(item => {
            items.push({
              id: Number(item.id),
              quantity: item.quantity || 1
            });
          });

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname
          });
        } else {
          // ✅ SINGLE ITEM → FormData
          delete config.headers['Content-Type'];
          if (sections) {
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch('/cart/add.js', config)
          .then(res => res.json())
          .then(async (response) => {

            if (response && response.status == 422) {
              window.commonCart.showToast(response.message, 'error');
            } else {
              await this.refreshSidebarCart();
            }

          })
          .catch(console.error)
          .finally(() => {
            this.setSubmitLoadingState(false);
            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      setSubmitLoadingState(isLoading) {
        if (!this.submitButton) return;

        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        this.submitButton.toggleAttribute('disabled', isLoading);
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      async refreshSidebarCart() {
        try {
          const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn('Could not fetch cart for count update', err);
        }

        const cartSidebar = document.querySelector('cart-sidebar');
        if (cartSidebar && typeof cartSidebar.updateCart === 'function') {
          await cartSidebar.updateCart();
          cartSidebar.openCart();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.bb-product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.bb-product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      getSelectedComplementaryProducts() {
        const upsell = document.querySelector('.bb-upsell');
        if (!upsell) return [];

        const items = [];
        upsell.querySelectorAll('.bb-upsell__item').forEach((item) => {
          const checkbox = item.querySelector('.bb-upsell__checkbox');
          if (!checkbox.checked) return;

          const variantSelect = item.querySelector('.bb-upsell__variant');
          items.push({
            id: variantSelect ? parseInt(variantSelect.value) : parseInt(checkbox.dataset.variantId),
            quantity: 1,
          });
        });

        return items;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
